<!-- Contact form -->
<div
    class="relative flex flex-col flex-auto items-center"
    [ngClass]="displayInDialog ? 'px-4' : 'px-6 sm:px-12'"
>
    <div class="w-full max-w-3xl">
        <form [formGroup]="businessAccountForm">
            <div class="flex" [ngClass]="displayInDialog ? 'mt-4' : 'mt-8'">
                <!-- First Name -->
                <div class="w-full">
                    <mat-form-field class="fuse-mat-no-subscript w-full">
                        <mat-label>Account Name</mat-label>
                        <mat-icon
                            matPrefix
                            class="hidden sm:flex icon-size-5"
                            [svgIcon]="'heroicons_solid:user-circle'"
                        ></mat-icon>
                        <input
                            matInput
                            [formControlName]="'name'"
                            [placeholder]="'Account Name'"
                            [spellcheck]="false"
                        />
                    </mat-form-field>
                    <mat-error
                        class="ml-4 absolute"
                        *ngIf="
                            businessAccountForm.get('name').invalid &&
                            (businessAccountForm.get('name').dirty ||
                                businessAccountForm.get('name').touched)
                        "
                    >
                        <mat-error
                            *ngIf="
                                businessAccountForm.get('name').errors?.required
                            "
                        >
                            This field is required.
                        </mat-error>
                        <mat-error
                            *ngIf="
                                businessAccountForm.get('name').errors
                                    ?.maxlength
                            "
                        >
                            This field must have at most 50 characters.
                        </mat-error>
                        <mat-error
                            *ngIf="
                                !businessAccountForm.get('name').errors
                                    ?.required &&
                                !businessAccountForm.get('name').errors
                                    ?.minlength &&
                                !businessAccountForm.get('name').errors
                                    ?.maxlength
                            "
                        >
                            Invalid first name format.
                        </mat-error>
                    </mat-error>
                </div>
            </div>

            <!-- Emails -->
            <div [ngClass]="displayInDialog ? 'mt-4' : 'mt-8'">
                <div class="space-y-4">
                    <ng-container
                        *ngFor="
                            let email of businessAccountForm.get('emails')[
                                'controls'
                            ];
                            let i = index;
                            let first = first;
                            let last = last;
                            trackBy: trackByFn
                        "
                    >
                        <div class="flex">
                            <div
                                class="flex-col w-full"
                                [ngClass]="{ 'mb-4': !displayInDialog }"
                            >
                                <mat-form-field
                                    class="fuse-mat-no-subscript w-full"
                                >
                                    <mat-label *ngIf="first">Email</mat-label>
                                    <mat-icon
                                        matPrefix
                                        class="hidden sm:flex icon-size-5"
                                        [svgIcon]="'mat_outline:email'"
                                    ></mat-icon>
                                    <input
                                        matInput
                                        [formControl]="email.get('value')"
                                        [placeholder]="'Email address'"
                                        [spellcheck]="false"
                                    />
                                </mat-form-field>
                                <mat-error
                                    class="absolute"
                                    *ngIf="
                                        email.get('value').invalid &&
                                        (email.get('value').dirty ||
                                            email.get('value').touched)
                                    "
                                >
                                    <mat-error
                                        *ngIf="
                                            email.get('value').errors?.required
                                        "
                                    >
                                        This field is required.
                                    </mat-error>
                                    <mat-error
                                        *ngIf="
                                            email.get('value').errors?.minlength
                                        "
                                    >
                                        This field must have at least 1
                                        character.
                                    </mat-error>
                                    <mat-error
                                        *ngIf="
                                            email.get('value').errors?.maxlength
                                        "
                                    >
                                        This field must have at most 250
                                        characters.
                                    </mat-error>
                                    <mat-error
                                        *ngIf="
                                            !email.get('value').errors
                                                ?.required &&
                                            !email.get('value').errors
                                                ?.minlength &&
                                            !email.get('value').errors
                                                ?.maxlength &&
                                            email.get('value').errors
                                                ?.emailValidator
                                        "
                                    >
                                        Invalid email format.
                                    </mat-error>
                                </mat-error>
                            </div>
                            <!-- Remove email -->
                            <ng-container
                                *ngIf="!(first && last) && allowMultipleEntries"
                            >
                                <div
                                    class="flex items-center w-10 pl-2"
                                    [ngClass]="{ 'mt-6': first }"
                                >
                                    <button
                                        class="w-8 h-8 min-h-8"
                                        mat-icon-button
                                        (click)="removeEmailField(i)"
                                        matTooltip="Remove"
                                    >
                                        <mat-icon
                                            class="icon-size-5"
                                            [svgIcon]="'heroicons_solid:trash'"
                                        >
                                        </mat-icon>
                                    </button>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                </div>
                <div
                    class="group inline-flex items-center mt-2 -ml-4 py-2 px-4 rounded cursor-pointer"
                    (click)="addEmailField()"
                    *ngIf="allowMultipleEntries"
                >
                    <mat-icon
                        class="icon-size-5"
                        [svgIcon]="'heroicons_solid:plus-circle'"
                    ></mat-icon>
                    <span
                        class="ml-2 font-medium text-secondary group-hover:underline"
                        >Add an email address</span
                    >
                </div>
            </div>

            <!-- Phone numbers -->
            <div [ngClass]="displayInDialog ? 'mt-4' : 'mt-8'">
                <div class="space-y-4">
                    <ng-container
                        *ngFor="
                            let phoneNumber of businessAccountForm.get(
                                'phoneNumbers'
                            )['controls'];
                            let i = index;
                            let first = first;
                            let last = last;
                            trackBy: trackByFn
                        "
                    >
                        <div class="flex">
                            <div
                                class="flex-col w-full"
                                [ngClass]="{ 'mb-4': !displayInDialog }"
                            >
                                <mat-form-field
                                    class="fuse-mat-no-subscript w-full"
                                >
                                    <mat-label *ngIf="first">Phone</mat-label>
                                    <input
                                        matInput
                                        [formControl]="phoneNumber.get('value')"
                                        [placeholder]="'1234567890'"
                                    />

                                    <mat-select
                                        class="mr-1.5"
                                        [formControl]="
                                            phoneNumber.get('country')
                                        "
                                        matPrefix
                                    >
                                        <mat-select-trigger>
                                            <span class="flex items-center">
                                                <span
                                                    class="hidden sm:flex w-6 h-4 mr-1 overflow-hidden"
                                                    [style.background]="
                                                        'url(\'/assets/images/apps/contacts/flags.png\') no-repeat 0 0'
                                                    "
                                                    [style.backgroundSize]="
                                                        '24px 3876px'
                                                    "
                                                    [style.backgroundPosition]="
                                                        getCountryByIso(
                                                            phoneNumber.get(
                                                                'country'
                                                            ).value
                                                        )?.flagImagePos
                                                    "
                                                ></span>
                                                <span
                                                    class="sm:mx-0.5 font-medium text-default"
                                                    >{{
                                                        getCountryByIso(
                                                            phoneNumber.get(
                                                                "country"
                                                            ).value
                                                        )?.code
                                                    }}</span
                                                >
                                            </span>
                                        </mat-select-trigger>
                                        <ng-container
                                            *ngFor="
                                                let country of countries;
                                                trackBy: trackByFn
                                            "
                                        >
                                            <mat-option [value]="country.iso">
                                                <span class="flex items-center">
                                                    <span
                                                        class="w-6 h-4 overflow-hidden"
                                                        [style.background]="
                                                            'url(\'/assets/images/apps/contacts/flags.png\') no-repeat 0 0'
                                                        "
                                                        [style.backgroundSize]="
                                                            '24px 3876px'
                                                        "
                                                        [style.backgroundPosition]="
                                                            country.flagImagePos
                                                        "
                                                    ></span>
                                                    <span class="ml-2">{{
                                                        country.name
                                                    }}</span>
                                                    <span
                                                        class="ml-2 font-medium"
                                                        >{{
                                                            country.code
                                                        }}</span
                                                    >
                                                </span>
                                            </mat-option>
                                        </ng-container>
                                    </mat-select>
                                </mat-form-field>
                                <mat-error
                                    class="absolute"
                                    *ngIf="
                                        phoneNumber.get('value').invalid &&
                                        (phoneNumber.get('value').dirty ||
                                            phoneNumber.get('value').touched)
                                    "
                                >
                                    <mat-error
                                        *ngIf="
                                            !phoneNumber.get('value').errors
                                                ?.required &&
                                            !phoneNumber.get('value').errors
                                                ?.minlength &&
                                            !phoneNumber.get('value').errors
                                                ?.maxlength &&
                                            phoneNumber.get('value').errors
                                                ?.phoneValidator
                                        "
                                    >
                                        Invalid phone number format.
                                    </mat-error>
                                </mat-error>
                            </div>
                            <!-- Remove phone number -->
                            <ng-container
                                *ngIf="!(first && last) && allowMultipleEntries"
                            >
                                <div
                                    class="flex items-center w-10 pl-2"
                                    [ngClass]="{ 'mt-6': first }"
                                >
                                    <button
                                        class="w-8 h-8 min-h-8"
                                        mat-icon-button
                                        (click)="removePhoneNumberField(i)"
                                        matTooltip="Remove"
                                    >
                                        <mat-icon
                                            class="icon-size-5"
                                            [svgIcon]="'heroicons_solid:trash'"
                                        >
                                        </mat-icon>
                                    </button>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                </div>
                <div
                    class="group inline-flex items-center mt-2 -ml-4 py-2 px-4 rounded cursor-pointer"
                    (click)="addPhoneNumberField()"
                    *ngIf="allowMultipleEntries"
                >
                    <mat-icon
                        class="icon-size-5"
                        [svgIcon]="'heroicons_solid:plus-circle'"
                    ></mat-icon>
                    <span
                        class="ml-2 font-medium text-secondary group-hover:underline"
                        >Add a phone number</span
                    >
                </div>
            </div>
            <!-- Tags -->
            <!-- <div class="flex flex-wrap items-center -m-1.5 mt-6"> -->
            <!-- Tags -->
            <!-- <ng-container *ngIf="contact.tags.length">
                  <ng-container *ngFor="let tag of (contact.tags | fuseFindByKey:'id':tags); trackBy: trackByFn">
                      <div class="flex items-center justify-center px-4 m-1.5 rounded-full leading-9 text-gray-500 bg-gray-100 dark:text-gray-300 dark:bg-gray-700">
                          <span class="text-md font-medium whitespace-nowrap">{{tag.title}}</span>
                      </div>
                  </ng-container>
              </ng-container> -->
            <!-- Tags panel and its button -->
            <!-- <div
                  class="flex items-center justify-center px-4 m-1.5 rounded-full leading-9 cursor-pointer text-gray-500 bg-gray-100 dark:text-gray-300 dark:bg-gray-700"
                  (click)="openTagsPanel()"
                  #tagsPanelOrigin>

                  <ng-container *ngIf="contact.tags.length">
                      <mat-icon
                          class="icon-size-5"
                          [svgIcon]="'heroicons_solid:pencil-square'"></mat-icon>
                      <span class="ml-1.5 text-md font-medium whitespace-nowrap">Edit</span>
                  </ng-container>

                  <ng-container *ngIf="!contact.tags.length">
                      <mat-icon
                          class="icon-size-5"
                          [svgIcon]="'heroicons_solid:plus-circle'"></mat-icon>
                      <span class="ml-1.5 text-md font-medium whitespace-nowrap">Add</span>
                  </ng-container>

                
                  <ng-template #tagsPanel>
                      <div class="w-60 rounded border shadow-md bg-card">
        
                          <div class="flex items-center m-3 mr-2">
                              <div class="flex items-center">
                                  <mat-icon
                                      class="icon-size-5"
                                      [svgIcon]="'mat_solid:search'"></mat-icon>
                                  <div class="ml-2">
                                      <input
                                          class="w-full min-w-0 py-1 border-0"
                                          type="text"
                                          placeholder="Enter tag name"
                                          (input)="filterTags($event)"
                                          (keydown)="filterTagsInputKeyDown($event)"
                                          [maxLength]="30"
                                          #newTagInput>
                                  </div>
                              </div>
                              <button
                                  class="ml-1"
                                  mat-icon-button
                                  (click)="toggleTagsEditMode()">
                                  <mat-icon
                                      *ngIf="!tagsEditMode"
                                      class="icon-size-5"
                                      [svgIcon]="'heroicons_solid:pencil-square'"></mat-icon>
                                  <mat-icon
                                      *ngIf="tagsEditMode"
                                      class="icon-size-5"
                                      [svgIcon]="'heroicons_solid:check'"></mat-icon>
                              </button>
                          </div>
                          <div
                              class="flex flex-col max-h-64 py-2 border-t overflow-y-auto">
                             
                              <ng-container *ngIf="!tagsEditMode">
                                  <ng-container *ngFor="let tag of filteredTags; trackBy: trackByFn">
                                      <div
                                          class="flex items-center h-10 min-h-10 px-4 cursor-pointer hover:bg-hover"
                                          (click)="toggleContactTag(tag)"
                                          matRipple>
                                          <mat-checkbox
                                              class="flex items-center h-10 min-h-10 pointer-events-none"
                                              [checked]="contact.tags.includes(tag.id)"
                                              [color]="'primary'"
                                              [disableRipple]="true">
                                          </mat-checkbox>
                                          <div class="ml-1">{{tag.title}}</div>
                                      </div>
                                  </ng-container>
                              </ng-container>
                          
                              <ng-container *ngIf="tagsEditMode">
                                  <div class="py-2 space-y-2">
                                      <ng-container *ngFor="let tag of filteredTags; trackBy: trackByFn">
                                          <div class="flex items-center">
                                              <mat-form-field class="fuse-mat-dense fuse-mat-no-subscript w-full mx-4">
                                                  <input
                                                      matInput
                                                      [value]="tag.title"
                                                      (input)="updateTagTitle(tag, $event)">
                                                  <button
                                                      mat-icon-button
                                                      (click)="deleteTag(tag)"
                                                      matSuffix>
                                                      <mat-icon
                                                          class="icon-size-5 ml-2"
                                                          [svgIcon]="'heroicons_solid:trash'"></mat-icon>
                                                  </button>
                                              </mat-form-field>
                                          </div>
                                      </ng-container>
                                  </div>
                              </ng-container>
                          
                              <div
                                  class="flex items-center h-10 min-h-10 -ml-0.5 pl-4 pr-3 leading-none cursor-pointer hover:bg-hover"
                                  *ngIf="shouldShowCreateTagButton(newTagInput.value)"
                                  (click)="createTag(newTagInput.value); newTagInput.value = ''"
                                  matRipple>
                                  <mat-icon
                                      class="mr-2 icon-size-5"
                                      [svgIcon]="'heroicons_solid:plus-circle'"></mat-icon>
                                  <div class="break-all">Create "<b>{{newTagInput.value}}</b>"</div>
                              </div>
                          </div>
                      </div>
                  </ng-template>
              </div> -->
            <!-- </div> -->

            <!-- Department -->
            <!-- <div class="mt-8">
              <mat-form-field class="fuse-mat-no-subscript w-full">
                  <mat-label>Department</mat-label>
                  <mat-icon matPrefix class="hidden sm:flex icon-size-5"
                      [svgIcon]="'heroicons_outline:briefcase'"></mat-icon>
                  <input matInput [formControlName]="'department'" [placeholder]="'Department'">
              </mat-form-field>
              <mat-error class="absolute"
                  *ngIf="businessAccountForm.get('department').invalid && (businessAccountForm.get('department').dirty || businessAccountForm.get('department').touched)">
                  <mat-error *ngIf="businessAccountForm.get('department').errors?.required">
                      This field is required.
                  </mat-error>
                  <mat-error *ngIf="businessAccountForm.get('department').errors?.maxlength">
                      This field must have at most 50 characters.
                  </mat-error>
                  <mat-error
                      *ngIf="!businessAccountForm.get('department').errors?.required && !businessAccountForm.get('department').errors?.minlength && !businessAccountForm.get('department').errors?.maxlength">
                      Invalid department format.
                  </mat-error>
              </mat-error>
          </div> -->
            <!-- Birthday -->
            <!-- <div class="mt-8">
              <mat-form-field class="fuse-mat-no-subscript w-full">
                  <mat-label>Date of birth</mat-label>
                  <mat-icon matPrefix class="hidden sm:flex icon-size-5" [svgIcon]="'heroicons_solid:cake'">
                  </mat-icon>
                  <input matInput [matDatepicker]="birthdayDatepicker" [max]="maxDate" [formControlName]="'birthDate'"
                      [placeholder]="'Birthday'">
                  <mat-datepicker-toggle matSuffix [for]="birthdayDatepicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker #birthdayDatepicker></mat-datepicker>
              </mat-form-field>
          </div> -->
            <!-- gender -->
            <!-- <div class="mt-8">
              <div class="fuse-mat-no-subscript w-full">
                  <span class="mb-4 text-black">Gender</span>
                  <span class="flex">
                      <mat-radio-group aria-labelledby="gender" class="mr-1.5 w-auto"
                          [formControlName]="'gender'">
                          <mat-radio-button class="mr-8"
                              *ngFor="let gender of genderArray; trackBy: trackByFn" [value]="gender">
                              {{ gender | enumToDescription:Gender}}
                          </mat-radio-button>
                      </mat-radio-group>
                  </span>

              </div>
          </div> -->
            <!-- Type -->
            <!-- <div class="mt-8 flex">
              <mat-form-field class="fuse-mat-no-subscript w-full">
                  <mat-label>Type</mat-label>
                  <mat-icon matPrefix class="hidden sm:flex icon-size-5"
                      [svgIcon]="'heroicons_solid:office-building'"></mat-icon>
                  <mat-select  [formControlName]="'type'">

                      <ng-container *ngFor="let type of contactTypeArray; trackBy: trackByFn">
                          <mat-option [value]="type">
                              {{type | enumToDescription:Type}}
                          </mat-option>
                      </ng-container>
                  </mat-select>
              </mat-form-field>
          </div> -->

            <!-- Mobile numbers -->
            <!-- <div class="mt-8">
              <div class="space-y-4">
                  <ng-container
                      *ngFor="let mobileNumber of businessAccountForm.get('mobileNumbers')['controls']; let i = index; let first = first; let last = last; trackBy: trackByFn">
                      <div class="flex">
                          <div class="flex-col w-full mb-4">
                          <mat-form-field class="fuse-mat-no-subscript w-full">
                              <mat-label *ngIf="first">Mobile Number</mat-label>
                              <input matInput [formControl]="mobileNumber.get('value')"
                                  [placeholder]="'Mobile'">
                              <mat-select class="mr-1.5" [formControl]="mobileNumber.get('country')"
                                  matPrefix>
                                  <mat-select-trigger>
                                      <span class="flex items-center">
                                          <span class="hidden sm:flex w-6 h-4 mr-1 overflow-hidden"
                                              [style.background]="'url(\'/assets/images/apps/contacts/flags.png\') no-repeat 0 0'"
                                              [style.backgroundSize]="'24px 3876px'"
                                              [style.backgroundPosition]="getCountryByIso(mobileNumber.get('country').value)?.flagImagePos"></span>
                                          <span
                                              class="sm:mx-0.5 font-medium text-default">{{getCountryByIso(mobileNumber.get('country').value)?.code}}</span>
                                      </span>
                                  </mat-select-trigger>
                                  <ng-container *ngFor="let country of countries; trackBy: trackByFn">
                                      <mat-option [value]="country.iso">
                                          <span class="flex items-center">
                                              <span class="w-6 h-4 overflow-hidden"
                                                  [style.background]="'url(\'/assets/images/apps/contacts/flags.png\') no-repeat 0 0'"
                                                  [style.backgroundSize]="'24px 3876px'"
                                                  [style.backgroundPosition]="country.flagImagePos"></span>
                                              <span class="ml-2">{{country.name}}</span>
                                              <span class="ml-2 font-medium">{{country.code}}</span>
                                          </span>
                                      </mat-option>
                                  </ng-container>
                              </mat-select>
                          </mat-form-field>
                          <mat-error class="absolute"
                          *ngIf="mobileNumber.get('value').invalid && (mobileNumber.get('value').dirty || mobileNumber.get('value').touched)">
                          <mat-error *ngIf="mobileNumber.get('value').errors?.maxlength">
                            This field must have 10 Number.
                          </mat-error>
                          <mat-error
                            *ngIf="!mobileNumber.get('value').errors?.required && !mobileNumber.get('value').errors?.minlength && !mobileNumber.get('value').errors?.maxlength && mobileNumber.get('value').errors?.phoneValidator">
                            Invalid mobile number format.
                          </mat-error>
                        </mat-error>
                        </div>
                          This line is comment Remove phone number
                          <ng-container *ngIf="!(first && last)">
                              <div class="flex items-center w-10 pl-2" [ngClass]="{'mt-6': first}">
                                  <button class="w-8 h-8 min-h-8" mat-icon-button
                                      (click)="removeMobileNumberField(i)" matTooltip="Remove">
                                      <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:trash'">
                                      </mat-icon>
                                  </button>
                              </div>
                          </ng-container>
                      </div>
                  </ng-container>
              </div>
              <div class="group inline-flex items-center mt-2 -ml-4 py-2 px-4 rounded cursor-pointer"
                  (click)="addMobileNumberField()">
                  <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:plus-circle'"></mat-icon>
                  <span class="ml-2 font-medium text-secondary group-hover:underline">Add a Mobile
                      number</span>
              </div>
          </div> -->
            <!-- Address -->
            <div [ngClass]="displayInDialog ? 'mt-4' : 'mt-8'">
                <div class="space-y-4">
                    <ng-container
                        *ngFor="
                            let address of businessAccountForm.get('addresses')[
                                'controls'
                            ];
                            let i = index;
                            let first = first;
                            let last = last;
                            trackBy: trackByFn
                        "
                    >
                        <div class="flex-wrap">
                            <!-- <div class="w-full mb-4">
                              <mat-form-field
                                  class="fuse-mat-no-subscript flex-auto w-full max-w-screen">
                                  <mat-label *ngIf="first">Street</mat-label>
                                  <mat-icon matPrefix class="hidden sm:flex icon-size-5"
                                      [svgIcon]="'heroicons_solid:location-marker'"></mat-icon>
                                  <input matInput [formControl]="address.get('street')"
                                      [placeholder]="'Street'" [spellcheck]="false">
                              </mat-form-field>
                              <mat-error class="absolute"
                                  *ngIf="address.get('street').invalid && (address.get('street').dirty || address.get('street').touched)">
                                  <mat-error *ngIf="address.get('street').errors?.required">
                                      This field is required.
                                  </mat-error>
                                  <mat-error *ngIf="address.get('street').errors?.maxlength">
                                      This field must have at most 250 characters.
                                  </mat-error>
                                  <mat-error
                                      *ngIf="!address.get('street').errors?.required && !address.get('street').errors?.minlength && !address.get('street').errors?.maxlength">
                                      Invalid designation format.
                                  </mat-error>
                              </mat-error>
                          </div> -->

                            <!-- <div class="flex mb-4 mt-3">
                              <div class="w-full">
                                  <mat-form-field
                                      class="fuse-mat-no-subscript flex-auto w-full max-w-24 sm:max-w-64   ">
                                      <mat-label *ngIf="first">Area</mat-label>
                                      <input matInput [formControl]="address.get('area')"
                                          [placeholder]="'Area'">
                                  </mat-form-field>
                                  <mat-error class="absolute "
                                      *ngIf="address.get('area').invalid && (address.get('area').dirty || address.get('area').touched)">
                                      <mat-error *ngIf="address.get('area').errors?.required">
                                          This field is required.
                                      </mat-error>
                                      <mat-error *ngIf="address.get('area').errors?.maxlength">
                                          This field must have at most 250 characters.
                                      </mat-error>
                                  </mat-error>
                              </div>
                              <div class="w-full">
                                  <mat-form-field
                                      class="fuse-mat-no-subscript flex-auto w-full max-w-screen">
                                      <mat-label *ngIf="first">City</mat-label>
                                      <input matInput [formControl]="address.get('city')"
                                          [placeholder]="'City'">
                                  </mat-form-field>
                                  <mat-error class="absolute ml-4"
                                      *ngIf="address.get('city').invalid && (address.get('city').dirty || address.get('city').touched)">
                                      <mat-error *ngIf="address.get('city').errors?.required">
                                          This field is required.
                                      </mat-error>
                                      <mat-error *ngIf="address.get('city').errors?.maxlength">
                                          This field must have at most 250 characters.
                                      </mat-error>
                                      <mat-error
                                          *ngIf="!address.get('city').errors?.required && !address.get('city').errors?.minlength && !address.get('city').errors?.maxlength">
                                          Invalid designation format.
                                      </mat-error>
                                  </mat-error>
                              </div>
                          </div> -->

                            <!-- <div class="w-full mb-4 mt-3">
                              <mat-form-field
                                  class="fuse-mat-no-subscript flex-auto w-full max-w-24 sm:max-w-screen ">
                                  <mat-label *ngIf="first">Landmark</mat-label>
                                  <input matInput [formControl]="address.get('landmark')"
                                      [placeholder]="'Landmark'">
                              </mat-form-field>
                              <mat-error class="absolute"
                                  *ngIf="address.get('landmark').invalid && (address.get('landmark').dirty || address.get('landmark').touched)">
                                  <mat-error *ngIf="address.get('landmark').errors?.required">
                                      This field is required.
                                  </mat-error>
                                  <mat-error *ngIf="address.get('landmark').errors?.maxlength">
                                      This field must have at most 250 characters.
                                  </mat-error>
                                  <mat-error
                                      *ngIf="!address.get('landmark').errors?.required && !address.get('landmark').errors?.minlength && !address.get('landmark').errors?.maxlength">
                                      Invalid designation format.
                                  </mat-error>
                              </mat-error>
                          </div> -->
                            <!-- <div class="flex mb-4 mt-3">
                              <div class="w-full">
                                  <mat-form-field
                                      class="fuse-mat-no-subscript flex-auto w-full max-w-24 sm:max-w-64 ">
                                      <mat-label *ngIf="first">District</mat-label>
                                      <input matInput [formControl]="address.get('district')"
                                          [placeholder]="'District'">
                                  </mat-form-field>
                                  <mat-error class="absolute"
                                      *ngIf="address.get('district').invalid && (address.get('district').dirty || address.get('district').touched)">
                                      <mat-error *ngIf="address.get('district').errors?.required">
                                          This field is required.
                                      </mat-error>
                                      <mat-error *ngIf="address.get('district').errors?.maxlength">
                                          This field must have at most 250 characters.
                                      </mat-error>
                                      <mat-error
                                          *ngIf="!address.get('district').errors?.required && !address.get('district').errors?.minlength && !address.get('district').errors?.maxlength && address.get('district').errors?.nameValidator ">
                                          Invalid district format.
                                      </mat-error>
                                  </mat-error>
                              </div>
                              <div class="w-full">
                                  <mat-form-field
                                      class="fuse-mat-no-subscript flex-auto w-full max-w-24 sm:max-w-64 sm:ml-4">
                                      <mat-label *ngIf="first">State</mat-label>
                                      <input matInput [formControl]="address.get('state')"
                                          [placeholder]="'State'">
                                  </mat-form-field>
                                  <mat-error class="absolute ml-4"
                                      *ngIf="address.get('state').invalid && (address.get('state').dirty || address.get('state').touched)">
                                      <mat-error *ngIf="address.get('state').errors?.required">
                                          This field is required.
                                      </mat-error>
                                      <mat-error *ngIf="address.get('state').errors?.maxlength">
                                          This field must have at most 250 characters.
                                      </mat-error>
                                      <mat-error
                              *ngIf="!address.get('state').errors?.required && !address.get('state').errors?.minlength && !address.get('state').errors?.maxlength && address.get('state').errors?.nameValidator ">
                              Invalid state format.
                          </mat-error>
                                  </mat-error>
                              </div>
                          </div> -->
                            <div
                                class="flex mt-3"
                                [ngClass]="{ 'mb-4': !displayInDialog }"
                            >
                                <div class="w-full">
                                    <mat-form-field
                                        class="fuse-mat-no-subscript flex-auto w-full max-w-24 sm:max-w-64 sm:ml-2"
                                    >
                                        <mat-label *ngIf="first"
                                            >Country</mat-label
                                        >
                                        <!-- <input matInput [formControl]="address.get('country')" [placeholder]="'Country'"> -->

                                        <mat-icon
                                            class="icon-size-5"
                                            [svgIcon]="
                                                'heroicons_solid:location-marker'
                                            "
                                            matPrefix
                                        ></mat-icon>
                                        <mat-select
                                            [formControl]="
                                                address.get('country')
                                            "
                                        >
                                            <mat-select-trigger>
                                                <span class="flex items-center">
                                                    <span
                                                        class="hidden sm:flex w-6 h-4 mr-1 overflow-hidden"
                                                        [style.background]="
                                                            'url(\'/assets/images/apps/contacts/flags.png\') no-repeat 0 0'
                                                        "
                                                        [style.backgroundSize]="
                                                            '24px 3876px'
                                                        "
                                                        [style.backgroundPosition]="
                                                            getCountryByIso(
                                                                address.get(
                                                                    'country'
                                                                ).value
                                                            )?.flagImagePos
                                                        "
                                                    ></span>
                                                    <span
                                                        class="sm:mx-0.5 font-medium text-default"
                                                        >{{
                                                            getCountryByIso(
                                                                address.get(
                                                                    "country"
                                                                ).value
                                                            )?.name
                                                        }}</span
                                                    >
                                                </span>
                                            </mat-select-trigger>

                                            <ng-container
                                                *ngFor="
                                                    let country of countries;
                                                    trackBy: trackByFn
                                                "
                                            >
                                                <mat-option
                                                    [value]="country.iso"
                                                >
                                                    <span
                                                        class="flex items-center"
                                                    >
                                                        <span
                                                            class="w-6 h-4 overflow-hidden"
                                                            [style.background]="
                                                                'url(\'/assets/images/apps/contacts/flags.png\') no-repeat 0 0'
                                                            "
                                                            [style.backgroundSize]="
                                                                '24px 3876px'
                                                            "
                                                            [style.backgroundPosition]="
                                                                country.flagImagePos
                                                            "
                                                        ></span>
                                                        <span class="ml-2">{{
                                                            country.name
                                                        }}</span>
                                                    </span>
                                                </mat-option>
                                            </ng-container>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-error
                                        class="absolute sm:ml-2"
                                        *ngIf="
                                            address.get('country').invalid &&
                                            (address.get('country').dirty ||
                                                address.get('country').touched)
                                        "
                                    >
                                        <mat-error
                                            *ngIf="
                                                address.get('country').errors
                                                    ?.required
                                            "
                                        >
                                            This field is required.
                                        </mat-error>
                                        <mat-error
                                            *ngIf="
                                                address.get('country').errors
                                                    ?.maxlength
                                            "
                                        >
                                            This field must have at most 250
                                            characters.
                                        </mat-error>
                                        <mat-error
                                            *ngIf="
                                                !address.get('country').errors
                                                    ?.required &&
                                                !address.get('country').errors
                                                    ?.minlength &&
                                                !address.get('country').errors
                                                    ?.maxlength &&
                                                address.get('country').errors
                                                    ?.nameValidator
                                            "
                                        >
                                            Invalid country format.
                                        </mat-error>
                                    </mat-error>
                                </div>
                                <!-- <div class="w-full">
                                  <mat-form-field
                                      class="fuse-mat-no-subscript flex-auto w-full max-w-24 sm:max-w-64 ml-2">
                                      <mat-label *ngIf="first">Pin Code</mat-label>
                                      <input matInput [formControl]="address.get('pincode')"
                                          [placeholder]="'Pin Code'">
                                  </mat-form-field>
                                  <mat-error class="absolute ml-4"
                                      *ngIf="address.get('pincode').invalid && (address.get('pincode').dirty || address.get('pincode').touched)">
                                      <mat-error *ngIf="address.get('pincode').errors?.required">
                                          This field is required.
                                      </mat-error>
                                      <mat-error *ngIf="address.get('pincode').errors?.maxlength">
                                          This field must have at most 6 number.
                                      </mat-error>
                                      <mat-error
                                          *ngIf="!address.get('pincode').errors?.required && !address.get('pincode').errors?.minlength && !address.get('pincode').errors?.maxlength && address.get('pincode').errors?.numberValidator">
                                          Invalid pincode format.
                                      </mat-error>
                                  </mat-error>
                              </div> -->
                            </div>
                            <!-- Remove Addresses -->
                            <!-- <ng-container *ngIf="!(first && last)">
                              <div class="flex items-center w-10 pl-2" [ngClass]="{'mt-6': first}">
                                  <button class="w-8 h-8 min-h-8" mat-icon-button
                                      (click)="removeAddressesField(i)" matTooltip="Remove">
                                      <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:trash'">
                                      </mat-icon>
                                  </button>
                              </div>
                          </ng-container> -->
                        </div>
                    </ng-container>
                </div>
                <!-- <div class="group inline-flex items-center mt-2 -ml-4 py-2 px-4 rounded cursor-pointer"
                  (click)="addAddressesField()">
                  <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:plus-circle'"></mat-icon>
                  <span class="ml-2 font-medium text-secondary group-hover:underline">Add New
                      address</span>
              </div> -->
            </div>
            <!-- websites numbers -->
            <!-- <div class="mt-8">
              <div class="space-y-4">
                  <ng-container
                      *ngFor="let website of businessAccountForm.get('websites')['controls']; let i = index; let first = first; let last = last; trackBy: trackByFn">
                      <div class="flex">
                          <div class="flex-col w-full mb-4">
                          <mat-form-field class="fuse-mat-no-subscript w-full">
                              <mat-label *ngIf="first">Website</mat-label>
                              <input matInput [formControl]="website.get('value')" [placeholder]="'websites'">                                       
                          </mat-form-field>
                        </div>
                          This line is comment Remove phone number
                          <ng-container *ngIf="!(first && last)">
                              <div class="flex items-center w-10 pl-2" [ngClass]="{'mt-6': first}">
                                  <button class="w-8 h-8 min-h-8" mat-icon-button
                                      (click)="removeWebsitesField(i)" matTooltip="Remove">
                                      <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:trash'">
                                      </mat-icon>
                                  </button>
                              </div>
                          </ng-container>
                      </div>
                  </ng-container>
              </div>
              <div class="group inline-flex items-center mt-2 -ml-4 py-2 px-4 rounded cursor-pointer"
                  (click)="addWebsitesField()">
                  <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:plus-circle'"></mat-icon>
                  <span class="ml-2 font-medium text-secondary group-hover:underline">Add a Web Sites</span>
              </div>
          </div> -->

            <!-- Notes -->
            <!-- <div class="mt-8">
              <mat-form-field class="fuse-mat-textarea fuse-mat-no-subscript w-full">
                  <mat-label>Notes</mat-label>
                  <mat-icon matPrefix class="hidden sm:flex icon-size-5"
                      [svgIcon]="'heroicons_solid:menu-alt-2'"></mat-icon>
                  <textarea matInput [formControlName]="'note'" [placeholder]="'Notes'" [rows]="5"
                      [spellcheck]="false" matTextareaAutosize></textarea>
              </mat-form-field>
          </div> -->

            <!-- Actions -->
            <div
                class="flex items-center mt-10 -mx-6 sm:-mx-12 py-4 pr-4 pl-1 sm:pr-12 sm:pl-7 border-t bg-gray-50 dark:bg-transparent"
                *ngIf="!displayInDialog"
            >
                <!-- Delete -->
                <!-- <button
                  mat-button
                  [color]="'warn'"
                  [matTooltip]="'Delete'"
                  (click)="deleteContact()">
                  Delete
              </button> -->
                <!-- Cancel -->
                <button
                    class="ml-auto"
                    mat-button
                    [matTooltip]="'Cancel'"
                    (click)="toggleEditMode(false)"
                >
                    Cancel
                </button>
                <!-- Save -->
                <button
                    class="ml-2"
                    mat-flat-button
                    [color]="'primary'"
                    [disabled]="businessAccountForm.invalid"
                    [matTooltip]="'Save'"
                    (click)="updateBusinessAccount()"
                >
                    Save
                </button>
            </div>

            <mat-dialog-actions
                align="end"
                class="-mb-3"
                *ngIf="displayInDialog"
            >
                <button
                    class="ml-auto"
                    mat-button
                    [matTooltip]="'Cancel'"
                    (click)="toggleEditMode(false)"
                >
                    Cancel
                </button>
                <!-- Save -->
                <button
                    class="ml-2"
                    mat-flat-button
                    [color]="'primary'"
                    [disabled]="businessAccountForm.invalid"
                    [matTooltip]="'Save'"
                    (click)="updateBusinessAccount()"
                >
                    Save
                </button>
            </mat-dialog-actions>
        </form>
    </div>
</div>
